import { blue } from '@synoptic/ui-kit/palette.js';
import { themeVars } from '@synoptic/ui-kit/theme/vars.ts';
import { borderRadius, boxShadows, space } from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { style } from '@vanilla-extract/css';

export const mentionNode = style({
  color: blue[400],
});

export const typeaheadPopoverContainer = style({
  // when in modal radix places pointer-events: none to whole body
  pointerEvents: 'auto',
});
export const typeaheadPopover = style({
  all: 'unset',
  display: 'block',
  listStyle: 'none',
  backgroundColor: themeVars.container.primary.background.idle,
  boxShadow: boxShadows.default,
  borderRadius: borderRadius.r8,
  outline: `1px solid ${themeVars.container.border.default}`,
  outlineOffset: '-1px',
  padding: space.s4,
  width: 300,
});

export const typeaheadPopoverItem = style({
  cursor: 'default',
  borderRadius: space.s4,
  minHeight: 34,
  padding: `${space.s8}px ${space.s12}px`,
  backgroundColor: themeVars.dropdownMenu.background.default,

  ':active': {
    backgroundColor: themeVars.dropdownMenu.background.active,
  },

  selectors: {
    '&[aria-selected="true"]': {
      backgroundColor: themeVars.dropdownMenu.background.hover,
    },
  },
});

export const typeaheadEmpty = style([
  typography['bodyMd'],
  {
    padding: `${space.s8}px ${space.s12}px`,
  },
]);
